<template>
<!--    <div   v-on:keyup.esc="close" >-->
<!--        <b-modal :active.sync="isComponentModalActive"-->
<!--                 :full-screen.sync="isFullScreen"-->
<!--                 has-modal-card  >-->

<!--            <div class="modal-card ">-->
<!--                <header class="modal-card-head"  >-->

<!--                    <section class="modal-card-body  "  >-->
<!--                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>-->

<!--                    </section>-->

<!--                </header>-->



<!--                <section class="modal-card-body"  >-->
<!--&lt;!&ndash;                    <h1>Select Pathogen</h1>&ndash;&gt;-->
<!--        {{dataListOfPathogen}}-->

<!--                    <b-table-->
<!--                            :data="dataListOfPathogen"-->
<!--                            bordered-->
<!--                            striped-->
<!--                            narrowed-->
<!--                            hoverable-->
<!--                            focusable-->
<!--                            mobile-cards>-->


<!--                        <b-table-column   label="Title" v-slot="props">-->
<!--                            {{ props.row.title }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column   label="Result Type" v-slot="props">-->
<!--                            {{ props.row.result_dat_aval }}-->
<!--                        </b-table-column>-->


<!--                    </b-table>-->




<!--                </section>-->


<!--                <footer class="modal-card-foot">-->
<!--                    <b-button type="is-danger" @click="closeBtn">Cancel</b-button>-->
<!--                    <b-button type="is-success" @click="save">Save</b-button>-->
<!--                </footer>-->


<!--            </div>-->


<!--        </b-modal>-->

<!--    </div>-->




    <div class="modal is-active" v-on:keyup.enter="saveChange"  v-on:keyup.esc="closeBtn" >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title "  >Select  <strong>  Pathogen </strong></p>
<!--                <p v-if="selectedItem" class=" modal-card-title has-text-grey-darker">Select <strong> {{selectedItem.title}}</strong></p>-->
                <button class="delete" aria-label="close" @click="closeBtn"></button>
            </header>
            <section class="modal-card-body">
                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <b-input   v-model="searchTitle" placeholder="» » » » Distemper  « « « «"></b-input>
<!--                           <p v-if="selectedItem" class="has-text-grey-darker">{{selectedItem.title}}</p>-->
                        </div>
                        <div class="level-item">

                        </div>
                    </div>
                    <div class="level-right">

                    </div>
                </nav>
                <b-table
                        :data="dataListOfPathogenFilter"
                        bordered
                        :striped="false"
                        narrowed
                        hoverable
                        focusable
                        mobile-cards
                        :selected.sync="selectedItem" >


                    <b-table-column   label="Title" v-slot="props">
                        {{ props.row.title }}
                    </b-table-column>

                    <b-table-column   label="Result Type"  v-slot="props">

                        <b-taglist>

                            <b-tag type="is-light" size="is-medium" v-for="dataRes in props.row.result_dat_aval.id"  :key="dataRes">
                                {{dataRes}}
                            </b-tag>

                        </b-taglist>



<!--                        {{ props.row.result_dat_aval }}-->
                    </b-table-column>

                    <b-table-column   label="#" v-slot="props">
                        <b-button type="is-info" @click="selectItem(props.row)">Select</b-button>
                    </b-table-column>

                </b-table>

            </section>
            <footer class="modal-card-foot"  style="justify-content: space-between;">
                <b-button type="is-danger" @click="closeBtn">Close</b-button>
                {{searchTitle}}
<!--<p v-if="selectedItem" >   <b-tag type="is-info" rounded> {{selectedItem.title}}  </b-tag></p>-->
<!--                <div class="buttons">-->
<!--                    <b-button type="is-primary"  >Inverted</b-button>-->
<!--                    <span v-if="selectedItem">{{selectedItem.title}}</span>-->
<!--                </div>-->
<!--                <p class="control"> <b-button type="is-success" >Pick up </b-button>-->
<!--                    <span v-if="selectedItem">{{selectedItem.title}}</span>-->
<!--                </p>-->

            </footer>
        </div>
    </div>



</template>

<script>
    import axios from "axios";
    import {  getBaseURLforBackEnd ,getConfigAxios }  from '@/utils.js'
    import { mapState } from "vuex";

    
    export default {
        name: "SelectPathogen",
        props:{
            isComponentModalActive : Boolean,
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
            dataListOfPathogenFilter: function () {
                return this.dataListOfPathogen.filter((dat)=>{
                    return dat.title.toUpperCase().indexOf(this.searchTitle.toUpperCase())> -1
                })
            }
        },
        methods:{
            selectItem(selectItemPayLoad){
                // console.log(JSON.stringify(selectItemPayLoad))
             this.$emit('closeWithSelectItem',selectItemPayLoad)
            },
            loadListOfPathogen(){
                const datTo = {
                    "admin" : false
                }

                const vm = this
                this.isFullScreenSearching = true
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(`${getBaseURLforBackEnd()}/api/listallpathogen`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(JSON.stringify(res))
                        vm.dataListOfPathogen = res.data
                        vm.isFullScreenSearching = false
                    })

                    .catch(err=>{
                        vm.isFullScreenSearching = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })

            },

            closeBtn(){
              this.$emit("close")
            },

        },
        data(){
            return {
                isFullScreen : false,
                isFullScreenSearching : false,


                dataListOfPathogen : [],
                selectedItem : null,

                searchTitle : ""

            }
        },
        watch:{
            isComponentModalActive : {
                immediate : true,
                handler : function (val) {
                     if(val){
                       this.loadListOfPathogen()
                     }
                }

            }
        }
    }
</script>

<style scoped>

</style>